
export function getCode(element: any) {
    if(!element){
        return null;
    }

    let code = element?.externalKeys?.code ? element.externalKeys.code : (element.code ? element.code : null)
    return code;
}

